"use strict";

var _toConsumableArray = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SensorInventoryAvailable = void 0;

var react_1 = __importDefault(require("react"));

var ReactiveComponent_1 = __importDefault(require("@appbaseio/reactivesearch/lib/components/basic/ReactiveComponent"));

var hooks_1 = require("../../hooks");

var SensorInventoryAvailable = function SensorInventoryAvailable() {
  var _ref = (0, hooks_1.useReactifySearchContext)(),
      options = _ref.options;

  var flagsHook = (0, hooks_1.useFlags)();

  var _ref2 = (0, hooks_1.useFilters)(),
      filterStack = _ref2.filterStack;

  if (!filterStack || "show_all" === filterStack.inventoryVisibility) {
    return null;
  }

  if (!flagsHook.flags["reactify-search:flag_sensor_inventoryavailable"]) {
    return null;
  }

  return react_1.default.createElement(ReactiveComponent_1.default, {
    componentId: "SensorInventoryAvailable",
    customQuery: function customQuery() {
      return {
        query: {
          bool: {
            should: [{
              bool: {
                must: [{
                  term: {
                    type: {
                      value: "product"
                    }
                  }
                }, {
                  nested: {
                    path: "variants",
                    query: {
                      match: {
                        "variants.available": true
                      }
                    }
                  }
                }]
              }
            }].concat(_toConsumableArray(options.mode === "instant-search" ? [] : [{
              term: {
                type: {
                  value: "callout"
                }
              }
            }])),
            minimum_should_match: "1"
          }
        }
      };
    }
  });
};

exports.SensorInventoryAvailable = SensorInventoryAvailable;